<template>
	<vs-popup
		id="error-with-loading"
		class="vs-con-loading__container"
		:title="$t('Routing.ROUTING_ERROR')"
		:active.sync="showErrors"
	>
		<vs-table v-if="optimizationErrors.length" ref="table" :max-items="7" :data="optimizationErrors" pagination>
			<template slot="thead">
				<vs-th sort-key="error">Error</vs-th>
				<vs-th sort-key="path">Path</vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							<p class="product-category">
								{{ `${$t("Optimization.Messages." + tr.message)}` }}
							</p>
						</vs-td>
						<vs-td>
							<vs-icon
								class="cursor-pointer"
								icon="info"
								size="small"
								color="primary"
								:title="tr.absolutePath"
							></vs-icon>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<div class="flex flex-wrap items-center justify-end">
			<vs-button class="mt-base mr-4" icon-pack="feather" icon="icon-copy" @click.prevent="onCopy"
				>{{ $t("SessionApi.Copy") }}
			</vs-button>
			<vs-button class="mt-base mr-4" icon-pack="feather" icon="icon-download" @click.prevent="exportToExcel"
				>{{ $t("Export") }}
			</vs-button>
		</div>
	</vs-popup>
</template>

<script>
export default {
	name: "OptimizationError",
	props: {
		errorsActive: {
			type: Boolean,
			default: () => false,
		},
		optimizationErrors: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			selectedFormat: "xlsx",
			headerTitle: ["Error", "Path"],
			headerVal: ["message", "absolutePath"],
		};
	},
	computed: {
		showErrors: {
			get() {
				return this.errorsActive;
			},
			set(val) {
				this.$emit("activePopupEmit", val);
			},
		},
	},
	methods: {
		exportToExcel() {
			import("@/vendor/Export2Excel").then((excel) => {
				const selectedRows = this.optimizationErrors.map((e, index) => {
					return {
						row: index + 1,
						absolutePath: e.absolutePath,
						message: this.$t("Optimization.Messages." + e.message),
					};
				});
				const list = selectedRows;
				const data = this.formatJson(this.headerVal, list);
				excel.export_json_to_excel({
					header: this.headerTitle,
					data,
					filename: this.$t("Routing.ROUTING_ERROR"),
					autoWidth: true,
					bookType: this.selectedFormat,
				});
			});
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) =>
				filterVal.map((j) => {
					return v[j];
				})
			);
		},
		onCopy() {
			const selectedRows = this.optimizationErrors.map((e, index) => {
				const item = index + 1;
				const error = this.$t("Optimization.Messages." + e.message);
				const path = e.absolutePath;
				return {item, path, error};
			});
			this.$copyText(JSON.stringify(selectedRows, null, 1))
				.then(() => {
					this.onSuccess();
				})
				.catch(() => {
					this.onError();
				});
		},
		onSuccess() {
			this.$vs.notify({
				title: this.$t("SessionApi.Copied"),
				text: this.$t("CopiedTextErrors"),
				color: "primary",
				iconPack: "feather",
				icon: "icon-check-circle",
			});
		},
		onError() {
			this.$vs.notify({
				title: this.$t("ErrorTitle"),
				text: this.$t("ErrorInCopying"),
				color: "warning",
				iconPack: "feather",
				icon: "icon-alert-circle",
			});
		},
	},
	beforeDestroy() {
		this.showErrors = false;
	},
};
</script>
